import { useMemo } from 'react';

export const useTikTokBrowserDetection = (): boolean => {
    const isTikTokBrowser = useMemo(() => {
        const userAgent = navigator.userAgent.toLowerCase();

        // Check for TikTok-specific patterns in user agent
        const tiktokPatterns = [
            'bytedancewebview',
            'musical_ly',
            'tiktok',
            'trill_430104'
        ];

        const isTikTok = tiktokPatterns.some(pattern => userAgent.includes(pattern));

        // Check if user has chosen to bypass the warning
        const bypassFlag = localStorage.getItem('tiktok_browser_bypass') === 'true';

        // Only show warning if it's TikTok and user hasn't bypassed
        return isTikTok && !bypassFlag;
    }, []);

    return isTikTokBrowser;
};
